import { render, staticRenderFns } from "./Agenda2020.vue?vue&type=template&id=23c30b54"
import script from "./Agenda2020.vue?vue&type=script&lang=js"
export * from "./Agenda2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports